import { Icon } from 'assets/index'
import { useState } from 'react'
import { PopUpContent, Button, ErrorMsg, Content } from './style'

interface IProps {
  onCancel: () => void
  handleDelete: () => Promise<any>
  alertTitle: string
  title: string
  description: string[]
}
const DeleteConfirmation = (props: IProps) => {
  const { onCancel, handleDelete, alertTitle, title, description } = props
  const [erro, setErro] = useState<string>('')

  const handleSubmit = async () => {
    await handleDelete().then((response: any) => {
      console.log(response)
      if (response?.fail || response === undefined) {
        setErro('Falha ao excluir')
      } else {
        onCancel()
      }
    })
  }

  return (
    <Content>
      <PopUpContent>
        <div className="alert-title-container">
          <img
            className="red-icon"
            src={Icon('alert_triangle.svg')}
            alt="alert"
          />
          <p className="big-red-title">{alertTitle}</p>
        </div>
        <p className="black-title">{title}</p>
        <p className="black-content">
          {description.map((item, index) => (
            <span key={index}>
              {item}
              <br />
            </span>
          ))}
        </p>

        <ErrorMsg>{erro}</ErrorMsg>
        <div className="button-container">
          <Button onClick={onCancel} data-testid={`cancel-btn`}>
            <img src={Icon('x.svg')} alt="close modal" className="icon" />
            <p>Cancelar</p>
          </Button>
          <div>
            <Button onClick={handleSubmit} red data-testid={`delete-btn`}>
              <img src={Icon('trash.svg')} alt="close modal" className="icon" />
              <p>Excluir definifivamente</p>
            </Button>
          </div>
        </div>
      </PopUpContent>
    </Content>
  )
}

export default DeleteConfirmation
